module.exports = (__webpack_require__(0))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/dialog.js from dll-reference girder_lib
// module id = 76
// module chunks = 0